export enum BankLinesSortingProperty {
  AmountAsc = 'amountAsc',
  AmountDesc = 'amountDesc',
  AmountDifference = 'amountDifference',
  DateAsc = 'dateAsc',
  DateDesc = 'dateDesc',
}
